document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const videoSections = document.querySelectorAll(
    '.video-strip, .supawstars-section'
  );

  videoSections.forEach((section) => {

    const cards = section.querySelectorAll(
      '.video-item, .supawstar-video'
    );

    const videos = section.querySelectorAll('video');

    const buttons = section.querySelectorAll(
      '.insta-btn, .follow-btn'
    );

    // Section fade-out
    gsap.fromTo(
      section,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'bottom 40%',
          end: 'bottom top',
          scrub: true
        }
      }
    );

    // Cards
    if (cards.length) {
      gsap.fromTo(
        cards,
        {
          y: 50,
          opacity: 0,
          scale: 0.96
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.7,
          stagger: 0.12,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse'
          }
        }
      );
    }

    // Videos
    videos.forEach((video) => {
      gsap.fromTo(
        video,
        {
          scale: 0.96
        },
        {
          scale: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: video,
            start: 'top 85%',
            toggleActions: 'play reverse play reverse'
          }
        }
      );
    });

    // Buttons (Instagram / Follow buttons)
    buttons.forEach((button) => {
      gsap.fromTo(
        button,
        {
          y: 12,
          opacity: 0,
          scale: 0.95
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          delay: 0.35,
          duration: 0.45,
          ease: 'back.out(1.7)',
          scrollTrigger: {
            trigger: button,
            start: 'top 90%',
            toggleActions: 'play reverse play reverse'
          }
        }
      );
    });

  });

  ScrollTrigger.refresh();
});
